import { render } from "./info-sidebar.vue?vue&type=template&id=621ec563"
import script from "./info-sidebar.vue?vue&type=script&lang=js"
export * from "./info-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/MBx/MBx/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__